export default function BrandNewHead() {
  return (
    <thead>
    <tr className='border-solid border-1 border-black'>
    <th>순위</th>
    <th>영화명</th>
    <th>매출액</th>
    <th>관객수</th>
    <th>증감률</th>
    </tr>
    </thead>    
  )
}
